module.exports = __webpack_public_path__ + "img/Documentation.3aa3cd4d.svg";